import axios from 'axios';

export const fetchSettings = (callback: () => void): void => {
  axios
    .get('/api/v1/settings')
    .then(function (result) {
      window.settings = result.data;
      callback();
    })
    .catch(function () {
      console.log('Failed to load settings'); // eslint-disable-line no-console
      window.Sentry.captureMessage('Failed to load settings');
    });
};
